import { Button, Form, ProgressBar } from 'react-bootstrap';
import PasswordFields, { passwordsReady } from './PasswordFields';

/**
 * Step 2 — Passwords (design read §3.4). "Read the certificate" sends the file in INSPECT mode:
 * the backend reads it and stores nothing. The form has `autoComplete="off"`.
 *
 * @param {{ upload: import('../../hooks/useCredentialUpload').CredentialUploadState }} props
 */
const PasswordStep = ({ upload }) => {
  const kind = upload.files?.kind ?? 'keystore';

  const submit = (event) => {
    event.preventDefault();
    if (passwordsReady(kind, upload.filled)) upload.inspect();
  };

  return (
    <Form onSubmit={submit} autoComplete="off">
      <PasswordFields
        kind={kind}
        idPrefix="fema-credential-inspect"
        fieldRefs={upload.passwordFields}
        onChange={upload.setPassword}
      />
      {upload.progress !== null ? (
        <ProgressBar
          className="mb-3"
          now={Math.round(upload.progress * 100)}
          label={`${Math.round(upload.progress * 100)}%`}
          aria-label="Upload progress"
        />
      ) : null}
      <div className="d-flex gap-2">
        <Button variant="outline-secondary" onClick={upload.back} disabled={upload.busy}>
          Back
        </Button>
        <Button type="submit" disabled={upload.busy || !passwordsReady(kind, upload.filled)}>
          Read the certificate
        </Button>
      </div>
    </Form>
  );
};

export default PasswordStep;
